export default __webpack_public_path__ + "static/media/Instructivo_Conectividad_Efectores_Colegiados_e_Instituciones.59759d3a.pdf";